import { Injectable } from "@angular/core";
import { HttprequestService } from "../httprequest.service";
import { serviziRest } from "src/environments/environment";

@Injectable({ providedIn: "root" })
export class BookingRulesService {
  orarioLimitePrenotazioneOmbr: number = 11;
  maxGgAbbonamentoPrenotabili: number = 12;
  numMaxOmbrelloniPrenotabili: number = 10;
  numMaxSdraio: number = 2;
  numMaxCuscini: number = 6;
  numMinCuscini: number = 4;
  numMinSdraio: number = 2;
  arrayNumMaxCuscini: any;
  arrayNumMaxSdraio: any;
  isSpiaggiaPrenotabile: boolean = true;
  isMezzeGiornateDisp: boolean = false;
  condizioniVendita: string = "";

  constructor(private http: HttprequestService) {}

  getLimiteOrarioPrenotazione() {
    this.http.doGet(serviziRest.getLimiteOrarioPrenotazione).subscribe(
      (res) => {
        if (res != null && res != undefined) {
          this.orarioLimitePrenotazioneOmbr = res;
        } else {
          this.orarioLimitePrenotazioneOmbr = 11;
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getNumeroCuscini() {
    this.http.doGetApplicationJsonBearer(serviziRest.getNumeroMaxCuscini).subscribe(
      (res) => {
        this.numMaxCuscini = res;
        this.arrayNumMaxCuscini = new Array(this.numMaxCuscini).fill(this.numMaxCuscini);
      },
      (error) => { console.log(error.status); }
    );
    this.http.doGetApplicationJsonBearer(serviziRest.getNumeroMinCuscini).subscribe(
      (res) => { this.numMinCuscini = res; },
      (error) => { console.log(error.status); }
    );
  }

  getNumeroSdraio() {
    this.http.doGetApplicationJsonBearer(serviziRest.getNumeroMaxSdraio).subscribe(
      (res) => {
        this.numMaxSdraio = res;
        this.arrayNumMaxSdraio = new Array(this.numMaxSdraio).fill(this.numMaxSdraio);
      },
      (error) => { console.log(error.status); }
    );
    this.http.doGetApplicationJsonBearer(serviziRest.getNumeroMinSdraio).subscribe(
      (res) => { this.numMinSdraio = res; },
      (error) => { console.log(error.status); }
    );
  }

  getNumeroGgAbbonamenti() {
    this.http.doGetApplicationJsonBearer(serviziRest.getMaxGgAbbonamento).subscribe(
      (res) => { this.maxGgAbbonamentoPrenotabili = res; },
      (error) => { console.log(error); }
    );
  }

  getMaxOmbrelloniPrenotabili() {
    this.http.doGetApplicationJsonBearer(serviziRest.maxOmbrelloniPrenotabiliPerUtente).subscribe(
      (res) => { this.numMaxOmbrelloniPrenotabili = res; },
      (error) => { console.log(error); }
    );
  }
}
